import { createParser, useQueryState } from "nuqs";

const selectedIdsParser = createParser({
  parse: (value: string): Record<string, boolean> => {
    if (!value) return {};
    try {
      return value.split(",").reduce(
        (acc, id) => {
          if (id.trim()) {
            acc[id.trim()] = true;
          }
          return acc;
        },
        {} as Record<string, boolean>,
      );
    } catch {
      return {};
    }
  },
  serialize: (value: Record<string, boolean>) => {
    const selectedIds = Object.keys(value).filter((id) => value[id]);
    return selectedIds.length > 0 ? selectedIds.join(",") : "";
  },
});

export const useArrayQueryState = (
  key: string,
  defaultValue: Record<string, boolean> = {},
  history: "replace" | "push" = "replace",
) => {
  return useQueryState(key, {
    ...selectedIdsParser,
    defaultValue,
    history,
    shallow: false,
  });
};
